import { ItiString } from "@/iti-core-react/utils/iti-string";
import { SortType } from "@/shared/enums/catalogue-search-filter-type";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SortDirection } from "@/shared/dtos/page-types.ts";
import { ICatalogueSearchFilter } from "@/shared/dtos/catalogue-search-filter-dto.ts";

interface CatalogueSearchFilterState {
	catalogueSearchFilter: ICatalogueSearchFilter;
}

const initialState: CatalogueSearchFilterState = {
	catalogueSearchFilter: {
		limit: 12,
		offset: 0,
		categories: [],
		owners: [],
		accessRights: [],
		terms: [],
		text: ItiString.Empty,
		sortBy: SortType.Name,
		sort: SortDirection.ASC,
	},
};

const searchFilterSlice = createSlice({
	name: "searchFilter",
	initialState,
	reducers: {
		setSearchFilter(
			state,
			action: PayloadAction<Partial<ICatalogueSearchFilter>>,
		) {
			state.catalogueSearchFilter = {
				...state.catalogueSearchFilter,
				...action.payload,
			};
		},
		resetSearchFilter(state) {
			// Restablecer el estado a su valor inicial
			state.catalogueSearchFilter = {
				...state.catalogueSearchFilter,
				...initialState.catalogueSearchFilter,
			};
		},
		updateAccessRightValue(state, action: PayloadAction<string[]>) {
			state.catalogueSearchFilter.accessRights = action.payload;
		},
	},
});

export default searchFilterSlice;
